var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',[_c('spinner')],1):_c('sport-store-container',{attrs:{"organization":_vm.organization,"schema":_vm.schema,"title":_vm.$t('membership'),"cover-url":_vm.organization.imageUrls.membershipCoverUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }